import { EditIcon } from 'assets/images/svg';
import React, { useState } from 'react';
import ManageDevicesToGroupModal from 'zComponents/molecules/ManageDevicesToGroupModal';
import { Button, Col, Row } from 'zui/Antd';

const DevicesPanelExtra = ({ groupID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = (e) => {
		e.stopPropagation();
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('Devices')) {
			setActiveKeys([...activeKeys, 'Devices']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('Devices')) {
					return [...prev, 'Devices'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Button type='text' icon={<EditIcon />} onClick={handleOpenModal} />
				<ManageDevicesToGroupModal visible={openModal} setVisible={handleCloseModal} groupID={groupID}>
					<div />
				</ManageDevicesToGroupModal>
			</Col>
		</Row>
	);
};

export default DevicesPanelExtra;
